import React, { Component } from "react";
import Button from "../../../../shared/button/button";
import { isMobile } from "./../../../../../js/components/searchform/utils/common";
import { intFormat } from "./../../../../../js/shared/utils";
import { MANAGER_LIMIT_AVERAGE_MILES } from "../../../shared/enums";
import Card from "./../../../../shared/Card/Card";
import ModalTerms from "./../../../../shared/ModalTerms/ModalTerms";
import { PARTICIPANT_DECLARATION, renderTermsDescription } from "../../../shared/terms";
import { TermsProvider } from "../../../../shared/Terms/TermsProvider";

class AccountLinkInvite extends Component {
	constructor() {
		super();
		this.state = {
			term: false,
			ifRenderModalTerms: false
		};

		this.nextStep = this.nextStep.bind(this);
	}

	onRenderModalTerms = () => {
		this.setState({
			ifRenderModalTerms: !this.state.ifRenderModalTerms
		});
	};

	nextStep() {
		localStorage.setItem("showWelcomeScreen", "1");
		this.props.incStep(this.state);
	}

	render() {
		const { ifRenderModalTerms } = this.state;

		return (
			<React.Fragment>
				{window.screen.availWidth <= 468 ? (
					<React.Fragment>
						<Card withoutMargin className="account-link-invite">
							<p>Olá!</p>
							<p>
								Você foi indicado por um gestor para participar da Conta Família e diversificar sua
								experiência na venda de milhas.
							</p>
							<p>
								O vínculo entre as contas deve ser acordado diretamente entre você e o gestor. Com o
								vínculo ativo, ele receberá pelas milhas negociadas por você.
							</p>
							<p>
								Para solicitar o vínculo com o gestor, você não pode ter nenhuma oferta ativa no
								momento.
							</p>
							<p>
								Vale lembrar que, com a conta vinculada, você poderá cadastrar ofertas com média de
								até 25.000 milhas por passageiro.
							</p>
							<h5 className="account-link-invite--before-start">Antes de começar</h5>

							<div className="no-padding no-margin col-xs-16 account-link-invite--need-to-send">
								<p>Você vai precisar nos enviar:</p>
							</div>

							<div className="col-xs-16 no-padding account-link-invite--document-list">
								<ul className="account-link-invite--documents">
									<li>Documento de identificação com foto (frente e verso)</li>
									<li>Foto do seu rosto ao lado de seu documento de identificação</li>
									<li>Declaração de Vínculo assinada e digitalizada</li>
								</ul>
							</div>
							<a
								className="account-link-invite--download-declaration"
								href={PARTICIPANT_DECLARATION}
								target="_blank"
							>
								<i className="icon-export" />
								Baixar Declaração de Vínculo
							</a>

							<p className="account-link-invite--rules">
								Conheça aqui as{" "}
								<a
									className="account-link-invite--rules-to-use"
									onClick={() => this.onRenderModalTerms()}
								>
									regras de utilização
								</a>.
							</p>
						</Card>
					</React.Fragment>
				) : (
					<React.Fragment>
						<Card withoutMargin className="account-link-invite">
							<h5 className="account-link-invite--title">Bem-vindo à Conta Família.</h5>
							<p>
								Você foi indicado por um <strong>gestor</strong> para participar da Conta Família e
								diversificar sua experiência na venda de milhas.
							</p>
							<p>
								O vínculo entre as contas deve ser acordado diretamente entre você e o gestor. Com o
								vínculo ativo, ele receberá pelas milhas negociadas por você.
							</p>
							<p>
								Para solicitar o vínculo com o gestor, você não pode ter nenhuma oferta ativa no
								momento. Vale lembrar que, com a conta vinculada, você poderá cadastrar ofertas com
								média de até {intFormat(MANAGER_LIMIT_AVERAGE_MILES)} milhas por passageiro.
							</p>
							<h5 className="account-link-invite--before-start">
								Você precisará enviar os documentos abaixo:
							</h5>
							<div className="col-xs-16 no-padding account-link-invite--document-list">
								<ul>
									<li>Documento de identificação com foto (frente e verso).</li>
									<li>Selfie segurando o documento de identificação ao lado do rosto.</li>
									<li>Declaração de Vínculo assinada e digitalizada.</li>
								</ul>
							</div>
							<a
								className="account-link-invite--download-declaration"
								href={PARTICIPANT_DECLARATION}
								target="_blank"
							>
								<i className="icon-export" />
								Baixar Declaração de Vínculo do participante
							</a>
							<p className="account-link-invite--rules">
								Conheça as{" "}
								<a
									className="account-link-invite--rules-to-use"
									onClick={() => this.onRenderModalTerms()}
								>
									regras de utilização da Conta Família para o participante.
								</a>
							</p>
						</Card>
					</React.Fragment>
				)}
				<div className="row row-botoes">
					{isMobile() ? (
						<div className="col-xs-16 account-link-invite--bottom">
							<div className="col-xs-16 text-right account-link-invite--bottom--button">
								<Button className="btn btn-primary" onClick={this.nextStep} type="button">
									Começar
								</Button>
							</div>
						</div>
					) : (
						<div className="col-xs-16 text-right account-link-invite--button">
							<Button className="btn btn-primary confirm-button" onClick={this.nextStep} type="button">
								Começar
							</Button>
						</div>
					)}
				</div>
				{ifRenderModalTerms && (
					<TermsProvider slug="family-account-participant">
						{({ content, loading, error }) => (
							<ModalTerms
								ifShow={ifRenderModalTerms}
								onClose={this.onRenderModalTerms}
								dataDescription={renderTermsDescription({ loading, error, content })}
							></ModalTerms>
						)}
					</TermsProvider>
				)}
			</React.Fragment>
		);
	}
}

export default AccountLinkInvite;
